import { render } from "./AddAddress.vue?vue&type=template&id=5179499b&scoped=true"
import script from "./AddAddress.vue?vue&type=script&lang=js"
export * from "./AddAddress.vue?vue&type=script&lang=js"

import "./AddAddress.vue?vue&type=style&index=0&id=5179499b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5179499b"]])

export default __exports__